import { Component } from '@angular/core';
import { MainService } from '../_services/main.service';
import { MechanicsService } from '../_services/mechanics.service';
import { ViennaObject } from '../../interfaces/ViennaSection.interface';

@Component({
	selector: 'dialog-principal-sections',
	templateUrl: './dialog-principal-sections.component.html',
	styleUrl: './dialog-principal-sections.component.css'
})
export class DialogPrincipalSectionsComponent {

	constructor(public mas:MainService,
		public ms:MechanicsService){

	}

	getPrincipalSections(): ViennaObject[] {
		// In learning mode: use listToDisplay with inModal filter
		// In production mode: return sections marked with inModal
		if (this.ms.selectedCategory) {
			// Learning mode - has selected category
			return this.mas.listToDisplay({ properties : ['inModal']});
		} else {
			// Production mode - no selected category
			return this.ms[this.ms.preferences.displayObjects].filter(s => s.inModal);
		}
	}

	getSelectedPrincipalSections(): ViennaObject[] {
		// In learning mode: use listToDisplay with inModal and selected filters
		// In production mode: return selected sections marked with inModal
		if (this.ms.selectedCategory) {
			// Learning mode - has selected category
			return this.mas.listToDisplay({ properties : ['inModal','selected']});
		} else {
			// Production mode - no selected category
			return this.ms[this.ms.preferences.displayObjects].filter(s => s.inModal && s.selected);
		}
	}

}
